import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotepadService {

  constructor() { }
  //let ckeditorDataArray = [];
  // editor save button enable
  private isEditorDataChange = new Subject<{ key: string; value: boolean; }>();
  _editorDataChange$ = this.isEditorDataChange.asObservable();

  editorDataUpdate(isDataChange: { key: string; value: boolean; }) {
    this.isEditorDataChange.next(isDataChange);
  }

  // editor comment value binding
  // private ckeditorCommentData = new Subject<string>();
  // _ckeditorCommentData$ = this.ckeditorCommentData.asObservable();

  // ckeditorCommentDataUpdate(comment: string) {
  //   this.ckeditorCommentData.next(comment);
  // }
  
  // editor comment value binding
  private ckeditorCommentData = new Subject<{ key: string; value: string; }>();
  _ckeditorCommentData$ = this.ckeditorCommentData.asObservable();

  ckeditorCommentDataUpdate(comment: { key: string; value: string; }) {
    this.ckeditorCommentData.next(comment);
  }
  // editor revision value binding
  private ckeditorRevisionData = new Subject<{ key: string; value: string; }>();
  _ckeditorRevisionData$ = this.ckeditorRevisionData.asObservable();

  ckeditorRevisionDataUpdate(revision: { key: string; value: string; }) {
    this.ckeditorRevisionData.next(revision);
  }
  // editor track value binding
  private ckeditorTrackData = new Subject<{ key: string; value: string; }>();
  _ckeditorTrackData$ = this.ckeditorTrackData.asObservable();

  ckeditorTrackDataUpdate(track: { key: string; value: string; }) {
    this.ckeditorTrackData.next(track);
  }
}

